export default __webpack_public_path__ + "static/login-bg-1e0ff6ad89444ddf8d2434f6a4fd9d6a.jpg";